<template>
  <v-card>
    <v-card-title>
      {{ analysis.$.name }}
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
          v-if="showEditor"
          cols="12"
          md="4"
          order="last"
          order-md="first"
        >
          <v-divider class="my-4 d-block d-md-none" />

          <analysis-editor
            :analysis="analysis"
            @change:chart="drawChart()"
            @change:pivot="updatePivot()"
            @change:model="loadData()"
          />
        </v-col>

        <v-col>
          <div ref="chart" />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-spacer />

      <v-btn
        v-if="!showEditor"
        v-t="'edit'"
        text
        @click="openEditor(true)"
      />

      <v-btn
        v-else
        v-t="'cancel'"
        text
        @click="openEditor(false)"
      />

      <v-btn
        v-if="showEditor"
        v-t="'save'"
        text
        color="primary"
        @click="saveWidget()"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
/**
 * Flow:
 * 1. Load Data -> when model change or need to refresh data
 * 2. Update Pivot -> when pivot report change (rows/cols/value/aggregation)
 * 3. Draw Chart -> when change chart type or options or when analysis is rendered
 */
import ApexCharts from 'apexcharts'

import AnalysisEditor from './AnalysisEditor'
import pivot from './pivot'
import { prepareData } from './WdrApexCharts'
import { db } from '@/plugins/stitch'
import Analysis from '@/models/Analysis'

export default {
  components: {
    AnalysisEditor
  },
  props: {
    analysis: {
      type: Analysis,
      default: new Analysis()
    }
  },
  data () {
    return {
      data: null,
      showEditor: false
    }
  },
  mounted () {
    if (this.analysis.isNew()) {
      this.showEditor = true
    }

    // If there is a pivot table, then plot it as-is
    if (this.analysis.pivotData) {
      this.drawChart()
    }
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy()
    }
  },
  methods: {
    async loadData () {
      if (!this.analysis.model) { return }

      const querySnap = await db
        .collection(this.analysis.model)
        .find({ organization: this.$currentOrganization.id })
        .asArray()

      this.data = []

      querySnap.forEach(doc => {
        delete doc._id
        this.data.push(doc)
      })

      this.updatePivot()
    },
    saveWidget () {
      this.analysis.save()
    },
    updatePivot () {
      if (this.analysis.report) {
        this.analysis.pivotData = pivot(this.data, this.analysis.report.slice)
        this.drawChart()
      }
    },
    drawChart () {
      if (!this.analysis.pivotData || !this.analysis.chartType) { return }

      const data = prepareData(this.analysis.pivotData, { type: this.analysis.chartType })

      data.chart.stacked = true
      data.chart.height = 350

      if (!data.series.length) { return }

      if (!this.chart) {
        this.chart = new ApexCharts(
          this.$refs.chart,
          data
        )
        this.chart.render()
      } else {
        this.chart.updateOptions(data)
      }
    },
    openEditor (open) {
      this.showEditor = open

      if (open) {
        this.loadData()
      } else {
        this.analysis.reset()
      }
    }
  }
}
</script>

<style lang="scss">

</style>
